module.exports = __webpack_public_path__ + "static/media/promo-overlay-registry.9c8b4f48.png";